import { render, staticRenderFns } from "./ViewStudentAnswers.vue?vue&type=template&id=82998ab2&scoped=true&"
import script from "./ViewStudentAnswers.vue?vue&type=script&lang=js&"
export * from "./ViewStudentAnswers.vue?vue&type=script&lang=js&"
import style0 from "./ViewStudentAnswers.vue?vue&type=style&index=0&id=82998ab2&lang=scss&scoped=true&"
import style1 from "./ViewStudentAnswers.vue?vue&type=style&index=1&id=82998ab2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82998ab2",
  null
  
)

export default component.exports